import React from 'react'
import './Loader.css';

const Loader = () => {
    return (
        <>
            <div className="loading-container">
                <h1 className="loading-text">Fetching data, please hold on...</h1>
                <div className="loader">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
        </>
    )
}

export default Loader